import type { CaseGenerationBatchDto } from "./api/types";

/**
 * Prepends the latest batch representation while keeping one row per batch id.
 * @param batches Existing generation batches.
 * @param batch Newly queued or updated batch.
 * @returns Batches with the supplied batch first and duplicate ids removed.
 */
export function prependUniqueGenerationBatch(
  batches: readonly CaseGenerationBatchDto[],
  batch: CaseGenerationBatchDto,
): readonly CaseGenerationBatchDto[] {
  return [batch, ...batches.filter((existingBatch) => existingBatch.id !== batch.id)];
}

/**
 * Selects a poll response unless local batch state changed while the request was pending.
 * @param currentBatches Current generation batches.
 * @param polledBatches Batches returned by the poll request.
 * @param requestRevision Local-state revision captured when polling started.
 * @param currentRevision Current local-state revision.
 * @returns The current batches for a stale response, otherwise the polled batches.
 */
export function selectPolledGenerationBatches(
  currentBatches: readonly CaseGenerationBatchDto[],
  polledBatches: readonly CaseGenerationBatchDto[],
  requestRevision: number,
  currentRevision: number,
): readonly CaseGenerationBatchDto[] {
  return requestRevision === currentRevision ? polledBatches : currentBatches;
}
